import React from 'react'
import styled from 'styled-components'
import { HORSE_POPUP_CLOSE } from "assets/images"

const ContentStyled = styled.div`
  height: 100%;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
  }
`

const MemoizedImageHorsePopupClose = () => {
  return (
    <ContentStyled>
      <img src={HORSE_POPUP_CLOSE} alt='' loading="lazy" />
    </ContentStyled>
  )
}
export default React.memo(MemoizedImageHorsePopupClose) 
